import config from '../../config'
import { authHeader } from '../utils/auth-header'

export const fixtureService = {
  getAll, getOne, insertOne, linkFixtureAndTeams, deleteMany, deleteOne, updateOne
}

async function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  let result = await fetch(`${config.apiUrl}/fixture?_limit=2000`, requestOptions)
  result = await result.json()

  return { data: { fixtures: result } }
}

async function getOne (id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  let result = await fetch(`${config.apiUrl}/graphql?query={ fixture(id:"${id}"){ _id, name, date_start, status, venue { _id, name } event { _id, name, competition{name} } fixtureteams{_id, side, team{_id, name}} venue{_id, name} } }`, requestOptions)
  result = await result.json()

  return result
}

async function insertOne (fixture) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(fixture)
  }
  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  let result = await fetch(`${config.apiUrl}/fixture`, requestOptions)
  result = await result.json()
  return result
}

async function linkFixtureAndTeams (fixtureId, homeTeamId, awayTeamId) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify({ side: 'Home', fixture: fixtureId, team: homeTeamId })
  }
  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  await fetch(`${config.apiUrl}/fixtureteam`, requestOptions)

  requestOptions.body = JSON.stringify({ side: 'Away', fixture: fixtureId, team: awayTeamId })

  await fetch(`${config.apiUrl}/fixtureteam`, requestOptions)

  return 'OK'
}

async function deleteMany (fixtureIds) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

  for (let fixtureId of fixtureIds) {
    await fetch(`${config.apiUrl}/fixture/${fixtureId}`, requestOptions)
  }

  return 'OK'
}

async function deleteOne (fixtureId) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

  await fetch(`${config.apiUrl}/fixture/${fixtureId}`, requestOptions)

  return 'OK'
}

async function updateOne (fixture) {
  let requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(fixture)
  }
  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  let result = await fetch(`${config.apiUrl}/fixture/${fixture._id}`, requestOptions)
  result = await result.json()

  return result
}



// WEBPACK FOOTER //
// ./src/services/fixture.js